import { reservationStatusText as reservationStatusText_1 } from '../strings.locstring.json';
import loc from 'owa-localize';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import TxpStyle from 'txp-data/lib/schema/viewSchema/TxpStyle';
import TxpDataRow from 'txp-data/lib/schema/viewSchema/TxpDataRow';
import { mergeStyles } from '@uifabric/merge-styles';
import { Icon } from 'office-ui-fabric-react/lib/Icon';

let styles = require('./ReservationStatus.scss');
let classNames = require('classnames');

/**
 * Interface of Reservation status props
 */
export interface ReservationStatusProps {
    status: TxpDataRow;
    txpStyle?: TxpStyle;
}

/**
 * Component which displays the reservation status
 */
export default observer(function ReservationStatus(props: ReservationStatusProps) {
    let { status, txpStyle } = props;
    let statusColor =
        txpStyle && txpStyle.primaryColor
            ? mergeStyles({
                  color: txpStyle.primaryColor,
              })
            : styles.reservationStatus;

    return (
        <div className={txpStyle.reservationStatus}>
            {status.icon && <Icon iconName={status.icon} className={txpStyle.iconStyle} />}
            {loc(reservationStatusText_1)}
            <span className={classNames(statusColor, styles.reservationStatusText)}>
                {status.text}
            </span>
        </div>
    );
});
